// extracted by mini-css-extract-plugin
export default {"l":"Text_l__CeG+5","m":"Text_m__CfvT6","s":"Text_s__IASPv","semibold":"Text_semibold__YrmNL","bold":"Text_bold__-NUWL","regular":"Text_regular__qsmXS","medium":"Text_medium__GuPZ2"};